/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { SUGGESTED_PROMPTS } from "../model/mockData";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

/** First-run view: mascot, personalised greeting, domain-correct starter chips. */
export default function EmptyState({ userName, onPick }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: 3,
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 56,
          height: 56,
          borderRadius: "16px",
          display: "grid",
          placeItems: "center",
          background: "linear-gradient(135deg, #3B6EF6, #7C5CFC)",
          color: "#fff",
          mb: 2,
        }}
      >
        <AutoAwesomeIcon sx={{ fontSize: 28 }} />
      </Box>

      <Typography sx={{ color: theme.palette.secondaryText.color, fontSize: 14 }}>
        {greeting()}{userName ? `, ${userName}` : ""}
      </Typography>
      <Typography sx={{ fontWeight: 600, fontSize: 20, color: theme.palette.text.color, mb: 3 }}>
        How can I help?
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", maxWidth: 320 }}>
        {SUGGESTED_PROMPTS.map((prompt) => (
          <Box
            key={prompt}
            role="button"
            tabIndex={0}
            onClick={() => onPick(prompt)}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onPick(prompt)}
            sx={{
              textAlign: "left",
              fontSize: 13,
              px: 1.5,
              py: 1.25,
              borderRadius: 2,
              cursor: "pointer",
              border: `1px solid ${theme.palette.border.color}`,
              color: theme.palette.text.color,
              transition: "all 0.15s ease",
              "&:hover": {
                borderColor: "#3B6EF6",
                transform: "translateY(-1px)",
              },
            }}
          >
            {prompt}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
